import { useObservable } from '@legendapp/state/react';
import { cartItemReferenceSynchronizationStore$ } from '../stores/cart-item-reference-synchronization.store';

/**
 * Hook to observe cart synchronization status
 *
 * @returns Current sync status: 'idle' | 'loading' | 'error' | 'success'
 *
 * @example
 * ```tsx
 * const CartHeader = () => {
 *     const syncStatus = useCartSyncStatus();
 *     const isSyncing = syncStatus === 'loading';
 *
 *     return (
 *         <View>
 *             {isSyncing && <ActivityIndicator />}
 *         </View>
 *     );
 * };
 * ```
 */
export const useCartSyncStatus = () => {
    const syncStatus = useObservable(cartItemReferenceSynchronizationStore$.syncStatus);
    return syncStatus.get();
};
